import "./OurCraft.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import PerfisEmAscensao from "./sections/PerfisEmAscensao";
import OurServices from "./sections/OurServices";
import Footer from "@/reusable_sections/Footer";
export default function OurCraftPage() {
  return <div>
      <FraternalExcellenceHeader />
      <PerfisEmAscensao />
      <OurServices />
      <Footer />
    </div>;
}